import { useNavigate } from "react-router-dom";
import Confirmation from "../../components/confirmation";
import TopHeader from "../../components/TopHeader";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import { useDispatch } from "react-redux";
import { slugify } from "../../utils/utils";

const ConfirmPage=()=>{
    const navigate=useNavigate()
    const dispatch=useDispatch()
    const [isCompleted,setIsCompleted]=useState(true)
      const { createStatus ,selectedEtablissement} = useSelector(state => state.etablissements);
      
      // console.log({selectedEtablissement})
      useEffect(()=>{
            dispatch(getMyEtablissement())
           setIsCompleted(
            selectedEtablissement?.adresse_postale!==null 
            && selectedEtablissement?.iban!==null
            && selectedEtablissement?.activite!==null
            && selectedEtablissement?.type!==null
            && selectedEtablissement?.domaine_activite!==null
            && selectedEtablissement?.lieu_intervention!==null
            && selectedEtablissement?.horaires?.length>0
            && selectedEtablissement?.equipes?.length>0
            && selectedEtablissement?.services?.length>0
            && selectedEtablissement?.photos?.length>0
          )
          },[])
return(
    <>
      <TopHeader bg={true} btn={true}/>
    <Confirmation 
    isCompleted={isCompleted}
    title={isCompleted ?"Votre page établissement est complétée !":"Vous n’êtes pas encore visible sur Twyny"}
    btnText={isCompleted &&"Voir ma page publique d’établissement"} 
    clickPrimary={()=>{navigate(`/etablissement/${selectedEtablissement?.slug}`,{state:{from:'inscription',idEtablissement:selectedEtablissement?.id}})}} 
    ctaLink={"/compte/prestataire/accueil"}
    ctatext={"Découvrir mon espace personnel"}
    /></>
    
)
}
export default ConfirmPage;